// Strg+V auf der Rechenseite (C7): Nur ein reines Bild wird zur Skizze.
// In Feldern bleibt Einfügen normal; Excel/Word legen Text und Bild
// zugleich ab, das ist kein Screenshot. Bei offenem Dialog nie.

export function isEditableTarget(el) {
  if (!el || el.nodeType !== 1) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return !!el.closest?.('[contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]');
}

const DIALOG = '[role="dialog"], [aria-modal="true"]';

export function imageFromPaste(event) {
  if (isEditableTarget(event?.target)) return null;
  // Offener Dialog (Export, Großansicht …): Die Skizze würde unsichtbar
  // ersetzt und die alte Datei gelöscht. Dann lieber gar nichts.
  if (event?.target?.closest?.(DIALOG) || document.querySelector(DIALOG)) return null;
  const dt = event?.clipboardData;
  if (!dt) return null;
  if ((dt.getData('text/plain') || '').trim()) return null;
  for (const item of Array.from(dt.items || [])) {
    if (item.kind === 'file' && item.type?.startsWith('image/')) return item.getAsFile();
  }
  return null;
}
